var _style, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallLighting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16.1px",
    height: "8px",
    viewBox: "0 0 16.1 8",
    style: {
      enableBackground: "new 0 0 16.1 8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.15;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:0.15;stroke-miterlimit:10;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Wall Lighting") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 3.8,
    className: "st0",
    width: 13.4,
    height: 0.4
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15.6,6.2 15.3,6.5 11.3,2 11.7,1.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "11.5,6.3 11.1,5.9 15.3,1.9 15.6,2.1  "
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.7,
    className: "st1",
    width: 0.4,
    height: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallLighting);
export default __webpack_public_path__ + "static/media/WallLighting.9cfd41dc8338f1f2546ca05d3f7908a2.svg";
export { ForwardRef as ReactComponent };